import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const CloseCircle = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12ZM3.12 12C3.12 16.9 7.1 20.89 12 20.89C16.9 20.89 20.88 16.9 20.88 12C20.88 7.1 16.9 3.11 12 3.11C7.1 3.11 3.12 7.1 3.12 12ZM15.94 7.18C16.18 6.94 16.58 6.94 16.82 7.18C17.06 7.42 17.06 7.82 16.82 8.06L12.89 11.99L16.82 15.92C17.06 16.16 17.06 16.56 16.82 16.8C16.7 16.92 16.54 16.98 16.38 16.98C16.22 16.98 16.06 16.92 15.94 16.8L12.01 12.87L8.08002 16.8C7.96002 16.92 7.80002 16.98 7.64002 16.98C7.48002 16.98 7.32002 16.92 7.20002 16.8C6.96002 16.56 6.96002 16.16 7.20002 15.92L11.13 11.99L7.20002 8.06C6.96002 7.82 6.96002 7.42 7.20002 7.18C7.44002 6.94 7.84002 6.94 8.08002 7.18L12.01 11.11L15.94 7.18Z"
    />
  </svg>
)

export default withDefaultStyles(CloseCircle)
